const declarationConfig = {
    feed: {
        filterLayout: 'DeclarationFilterDefaultLayout',
        listLayout: 'DeclarationListFeedLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getDeclaration',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getCategoryFunc: 'getDeclarationCategory',
        isCategory: true,
        categoryApiParamSet: {},
    },
    today: {
        filterLayout: 'DeclarationFilterDefaultLayout',
        listLayout: 'DeclarationListTodayLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getTodayDeclaration',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getCategoryFunc: 'getDeclarationCategory',
        isCategory: true,
        categoryApiParamSet: {},
    },
    user: {
        filterLayout: 'DeclarationFilterUserLayout',
        listLayout: 'DeclarationListUserLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getUserDeclaration',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getCategoryFunc: 'getUserDeclarationCategory',
        isCategory: true,
        categoryApiParamSet: {},
    },
}

export default {
    methods: {
        returnDeclarationConfig(type) {
            return declarationConfig[type];
        },
    },
    filterConfig: {
        dmid: { // 신고자 ID
            type: 'query',
            classname: 'searchInput',
        },
        wmid: { // 신고 당한 ID
            type: 'query',
            classname: 'searchInput',
        },
        wid: { // 게시물 번호
            type: 'match',
            classname: 'searchInput',
        },
        cr: { // 작성일
            type: 'between',
            classname: 'filterDate',
        },
        ty: { // 피드 게시물
            type: 'match',
            classname: 'searchType',
        },
        mbni: { // 사용자 신고에서 신고자 ID
            type: 'query',
            classname: 'searchInput',
        },
        mbwi: { // 사용자 신고에서 신고 당한 ID
            type: 'query',
            classname: 'searchInput',
        },
    },
}